import * as actions from './actions'
import getTheme from '../../config/theme-config'
import {
    LOCALE_CODES,
    LOCAL_LOCALE_KEY,
    LOCAL_DATA_KEY,
    HOTSWAP_PERMISSIONS,
    DEFAULT_DASHBOARD_MAP_SWITCHER_OPTION
} from './constants'
import getLocale from '../../config/locale-config'

const initState = {
    isLoading: false,
    notifications: [],
    isRouteChecked: false,
    theme: getTheme('polar'),
    localeCode: localStorage.getItem(LOCAL_LOCALE_KEY) || LOCALE_CODES.de,
    locale: localStorage.getItem(LOCAL_LOCALE_KEY)
        ? getLocale(localStorage.getItem(LOCAL_LOCALE_KEY))
        : getLocale(LOCALE_CODES.de),
    token: localStorage.getItem(LOCAL_DATA_KEY)
        ? JSON.parse(localStorage.getItem(LOCAL_DATA_KEY)).token
        : null,
    p: localStorage.getItem(LOCAL_DATA_KEY)
        ? JSON.parse(localStorage.getItem(LOCAL_DATA_KEY)).p
        : null,
    user: localStorage.getItem(LOCAL_DATA_KEY)
        ? JSON.parse(localStorage.getItem(LOCAL_DATA_KEY)).user
        : null,
    i: localStorage.getItem(LOCAL_DATA_KEY)
        ? JSON.parse(localStorage.getItem(LOCAL_DATA_KEY)).i
        : null,
    isTermsStep: false,
    tempCreds: null,
    twoFactorToken: null,
    // needed only to check if token reload is pending
    profileUser: null,
    hasTomDevices: false,
    organisationData: null,
    dashboardType: DEFAULT_DASHBOARD_MAP_SWITCHER_OPTION,
    userNotificationsSettings: {
        mail_notification_enabled: false,
        sms_notification_enabled: false,
        push_notification_enabled: false,
        notificate_triggered: false,
        notificate_inactive: false,
        notificate_battery: false,
        notificate_trap_set: false,
        notificate_back_online: false,
        notificate_unstable_wifi: false,
        notificate_bait_low: false,
        notificate_activity_threshold_reached: false,
        notificate_bait_low_and_activity_threshold_reached: false
    }
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.SWITCH_THEME:
            return {
                ...state,
                ...{
                    theme: action.theme
                }
            }
        case actions.SET_LOCALE:
            localStorage.setItem(LOCAL_LOCALE_KEY, action.localeCode)
            return {
                ...state,
                ...{
                    localeCode: action.localeCode,
                    locale: getLocale(action.localeCode)
                }
            }
        case actions.START_LOADING:
            return {
                ...state,
                ...{
                    isLoading: action.isLoading
                }
            }
        case actions.STOP_LOADING:
            return {
                ...state,
                ...{
                    isLoading: action.isLoading
                }
            }
        case actions.ENQUEUE_SNACKBAR:
            return {
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        key: action.key,
                        ...action.notification
                    }
                ]
            }
        case actions.CLOSE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.map(notification =>
                    action.dismissAll || notification.key === action.key
                        ? { ...notification, dismissed: true }
                        : { ...notification }
                )
            }
        case actions.REMOVE_SNACKBAR:
            return {
                ...state,
                notifications: state.notifications.filter(
                    notification => notification.key !== action.key
                )
            }
        case actions.LOGIN_SUCCESS: {
            const traplinkedData = {
                user: action.user,
                p: action.p,
                token: action.token
            }
            localStorage.setItem(LOCAL_DATA_KEY, JSON.stringify(traplinkedData))
            return {
                ...state,
                ...{
                    token: action.token,
                    user: action.user,
                    p: action.p,
                    twoFactorToken: null
                }
            }
        }
        case actions.LOGOUT:
            for (let key of Object.values(HOTSWAP_PERMISSIONS)) {
                localStorage.removeItem(key)
            }
            return {
                ...state,
                ...{
                    token: null,
                    user: null,
                    p: null,
                    twoFactorToken: null
                }
            }
        case actions.SET_TWO_FACTOR_TOKEN:
            return {
                ...state,
                ...{
                    twoFactorToken: action.twoFactorToken
                }
            }
        case actions.PROFILE_UPDATE_SUCCESS: {
            const updatedUser = {
                ...state.user,
                ...action.userData
            }
            const traplinkedData = JSON.parse(
                localStorage.getItem(LOCAL_DATA_KEY)
            )
            const updatedTraplinkedData = {
                ...traplinkedData,
                ...{
                    user: updatedUser
                }
            }
            localStorage.setItem(
                LOCAL_DATA_KEY,
                JSON.stringify(updatedTraplinkedData)
            )
            return {
                ...state,
                ...{
                    user: updatedUser
                }
            }
        }
        case actions.SET_IS_TERMS_STEP:
            return {
                ...state,
                ...{
                    isTermsStep: action.isTermsStep
                }
            }
        case actions.SET_TEMP_CREDS:
            return {
                ...state,
                ...{
                    tempCreds: action.tempCreds
                }
            }
        case actions.GET_PROFILE_USER_SUCCESS:
            return {
                ...state,
                ...{
                    profileUser: action.user
                }
            }
        case actions.GET_HAS_TOM_DEVICES_SUCCESS:
            return {
                ...state,
                ...{
                    hasTomDevices: action.hasTomDevices
                }
            }
        case actions.GET_ORGANISATION_DATA_SUCCESS:
            return {
                ...state,
                ...{
                    organisationData: action.organisationData
                }
            }
        case actions.CHANGE_DASHBOARD_TYPE:
            return {
                ...state,
                dashboardType: action.option
            }
        case actions.SET_USER_NOTIFICATIONS_SETTINGS:
            return {
                ...state,
                userNotificationsSettings: {
                    ...state.userNotificationsSettings,
                    [`${action.notifications.name}`]:
                        action.notifications.checked
                }
            }
        case actions.CLEAN_USER_NOTIFICATIONS_SETTINGS:
            return {
                ...state,
                userNotificationsSettings: {
                    mail_notification_enabled: false,
                    sms_notification_enabled: false,
                    push_notification_enabled: false,
                    notificate_triggered: false,
                    notificate_inactive: false,
                    notificate_battery: false,
                    notificate_trap_set: false,
                    notificate_back_online: false,
                    notificate_unstable_wifi: false,
                    notificate_bait_low: false,
                    notificate_activity_threshold_reached: false,
                    notificate_bait_low_and_activity_threshold_reached: false
                }
            }
        case actions.IMPERSONATE_SUCCESS: {
            const traplinkedImpersonateData = {
                user: action.user,
                p: action.p,
                token: action.token,
                i: action.i
            }
            localStorage.setItem(
                LOCAL_DATA_KEY,
                JSON.stringify(traplinkedImpersonateData)
            )
            return {
                ...state,
                ...{
                    token: action.token,
                    user: action.user,
                    p: action.p,
                    i: action.i
                }
            }
        }

        default:
            return state
    }
}
